import React from 'react';
import { Store, Provider as ReduckProvider } from '@reduck/core';

interface GarfishReduckContextType {
  store: Store;
}

const Context = React.createContext<GarfishReduckContextType>(null as any);

const Provider = ({ store, children }: any) => {
  return ReduckProvider({ store, children, context: Context });
};

export { Context, Provider };
